import { useSyncExternalStore } from 'react';

const subscribe = (): (() => void) => () => {};

/**
 * `false` on the server and during hydration, `true` once hydrated (and on every later client
 * render). Values that only the client knows (media queries, storage) should fall back to the
 * server value until then: React does not patch attributes that differ during hydration, so a
 * first client render that disagrees with the server markup leaves the server value in the DOM.
 * The switch to `true` is a regular re-render, which React does apply.
 */
export const useHydrated = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
